



















































































































import { Vue, Component, Watch, Prop } from "@/shared/vuepack";
import {
  Expense,
  PossibleExpense,
  ExpenseCategory,
  ExpenseRecurringType,
  ExpenseEligibility
} from "@/shared/types";
import CategoryPill from "@/shared/components/CategoryPill.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import Button from "@/shared/components/ui/Button.vue";
import { formatCurrency } from "@/shared/currency";
import * as _ from "lodash";
import { Validator } from "vee-validate";
import EvidenceUpload from "./EvidenceUpload.vue";
import { useExpenseStore } from "@/employee/store/expense";
import moment from "moment";
@Component ({
  components: {
    Button,
    CategoryPill,
    EvidenceUpload,
    RadioButton
  }
})
export default class EditExpenseForm extends Vue {
  @Prop({required: true})
  transactionId: number;

  @Prop()
  eligibleAmount: number;

  @Prop({required: true})
  expense: any; // Expense

  @Prop()
  transactionType: number;

  @Prop()
  addExpenseMode: boolean;

  @Prop({required: true})
  onSubmit: () => void;

  @Prop()
  editExpenseSource: string;

  expenseStore = useExpenseStore();

  ExpenseRecurringType = ExpenseRecurringType;
  isSubmitting = false;
  initialEligibleAmount = 0;

  $validator: Validator;

  formatCurrency = formatCurrency;

  updatedExpense: Expense = null;
  categories = [
    {value: "medical", display: "Medical", category: ExpenseCategory.Medical},
    {value: "dental", display: "Dental", category: ExpenseCategory.Dental},
    {value: "pharmacy", display: "Pharmacy", category: ExpenseCategory.Pharmacy},
    {value: "eye", display: "Vision", category: ExpenseCategory.Eye},
    {value: "other", display: "Other", category: ExpenseCategory.Other}
  ];

  get canSubmitForm () { return this.$validator.errors.any() === false && this.isSubmitting === false; }

  @Watch("expense", { deep: true })
  updateExpenseAttachments () {
    this.updatedExpense.expenseEvidenceAttachments = this.expense.expenseEvidenceAttachments;
    this.updatedExpense.attachmentNames = this.expense.attachmentNames;
  }

  save (e) {
    e.preventDefault();
    const isAmountChanged = this.updatedExpense.amount !== this.initialEligibleAmount;
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      this.isSubmitting = true;

      this.expenseStore.updateExpense({
        transactionId: this.transactionId,
        expense: this.updatedExpense,
        expenseType: this.transactionType,
        isEligibleAmountChanged: isAmountChanged
      }).then(() => {
        this.isSubmitting = false;
        this.onSubmit();
        });

      if (!this.transactionId) {
        this.copyFormModel();
      }
    });
  }

  addFamilyMember (e) {
    e.preventDefault();
  }

  addFiles (files) {
    this.updatedExpense.expenseEvidenceAttachments = files;
  }

  close (e) {
    e.preventDefault();
    this.onSubmit();
  }

  get eligibleAmountValidator () {
    return this.expense.transactionAmount ? this.validatorForTransactionExpense : this.validatorForManualExpense;
  }

  get validMinimumTransactionAmount () {
    return this.addExpenseMode || this.editExpenseSource === "confirmNew" ? 0.01 : 0;
  }

  get validMinimumManualAmount () {
    if (this.addExpenseMode || this.transactionType === 1) {
      return 0.01;
    }

    return 0;
  }

  get validatorForTransactionExpense () {
    return {
        required: true,
        decimal: 2,
        min_value_usd: this.validMinimumTransactionAmount,
        max_value_usd: this.expense.transactionAmount
    };
  }

  get validatorForManualExpense () {
    return {
        required: true,
        decimal: 2,
        min_value_usd: this.validMinimumManualAmount
    };
  }

  beforeMount () {
    this.copyFormModel();
  }

  copyFormModel () {
    const expense = this.expense;
    this.updatedExpense = {
        id: expense.id,
        name: expense.name,
        amount: this.eligibleAmount,
        reimbursedAmount: expense.reimbursedAmount,
        comment: expense.comment,
        expensePaid: expense.expensePaid,
        recurringType: expense.recurringType,
        expenseCategory: expense.expenseCategory,
        attachmentNames: expense.attachmentNames,
        eligibilityStatus: expense.expenseStatus,
        expenseEvidenceAttachments: expense.expenseEvidenceAttachments,
        institutionName: expense.institutionName,
        dateOfService: expense.dateOfService,
        transactionAmount: expense.transactionAmount,
        isManualExpense: expense.isManualExpense
    };
    this.initialEligibleAmount = this.updatedExpense.amount;

    if (typeof (this.updatedExpense.dateOfService) === "undefined") {
      this.updatedExpense.dateOfService = null;
    }
  }

  createDownloadLink (filename: string) {
    this.expenseStore.expenseAttachmentGet({
      expense: this.expense,
      attachmentName: filename
    } as any);
  }

  removeAttachment (attachmentName: string) {
    this.expenseStore.expenseAttachmentRemove({
      expense: this.expense,
      transactionType: this.transactionType,
      attachmentName
    });
  }

  @Watch("transactionId")
  onTransactionPropChange () {
    this.copyFormModel();
  }
  get today (): string {
    return moment().format("MM/DD/YYYY");
  }
}
